import CheckInForm from "views/admin/CheckInForm";
import ClientDetailsPublicForm from "views/public/ClientDetailsPublicForm";
import PrEnquiryPublicForm from "views/public/PrEnquiryPublicForm";
import ClientIntakeForm from "views/client/ClientIntakeForm";
import ReferralOnboardingPage from "views/public/ReferralOnboardingPage";

const CheckInRoute = {
  path: "/",
  element: null,
  children: [
    {
      path: "client/check-in/:slug",
      element: <CheckInForm />,
    },
    {
      path: "client/details/:slug",
      element: <ClientDetailsPublicForm />,
    },
    {
      path: "client/pr-enquiry/:slug",
      element: <PrEnquiryPublicForm />,
    },
    {
      path: "client/intake/:token",
      element: <ClientIntakeForm />,
    },
    {
      path: "referral/onboarding/:token",
      element: <ReferralOnboardingPage />,
    },
  ],
};

export default CheckInRoute;
